export enum EAccessField {
  DESCRIPTION = 'DESCRIPTION',
  COMMENT = 'COMMENT',
  CUSTOM_FIELD = 'CUSTOM_FIELD',
}
